/* fotomalovanky.cz — the dotted paper-plane route that runs down the page
   (desktop only). Degrades gracefully: without JS the route simply does not
   render. */
(function () {
  'use strict';

  if (window.__fmUiLoaded) return;
  window.__fmUiLoaded = true;

  /* click-to-zoom for the sample and product photos */
  var ZOOM_SELECTOR = '.fm-pair__cell img, .fm-samples__colored .fm-photo-card img, .fm-product__photos .fm-photo-card img';
  var lightbox = null;

  document.addEventListener('click', function (event) {
    var img = event.target;
    if (!img.matches || !img.matches(ZOOM_SELECTOR)) return;
    if (!window.HTMLDialogElement) return;
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'fm-lightbox';
      lightbox.innerHTML = '<img alt="">';
      lightbox.addEventListener('click', function () { lightbox.close(); });
      document.body.appendChild(lightbox);
    }
    var big = lightbox.querySelector('img');
    big.src = img.src;
    if (img.srcset) big.srcset = img.srcset;
    big.sizes = '92vw';
    big.alt = img.alt || '';
    lightbox.showModal();
  });

  /* page dots under the mobile swipe rows (auto-hidden when nothing scrolls) */
  function initSwipeDots() {
    var rows = document.querySelectorAll('.fm-samples__grid, .fm-samples__colored, .fm-cards__grid, .fm-reviews__cols');
    Array.prototype.forEach.call(rows, function (row) {
      if (row.dataset.fmDots) return;
      row.dataset.fmDots = '1';
      var dots = document.createElement('div');
      dots.className = 'fm-dots';
      row.insertAdjacentElement('afterend', dots);
      var update = function () {
        var pages = Math.max(1, Math.round(row.scrollWidth / row.clientWidth));
        var idx = Math.min(pages - 1, Math.round(row.scrollLeft / row.clientWidth));
        if (dots.childElementCount !== pages) {
          dots.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            (function (n) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'fm-dots__dot';
              b.setAttribute('aria-label', 'Strana ' + (n + 1));
              b.addEventListener('click', function () {
                row.scrollTo({ left: n * row.clientWidth, behavior: 'smooth' });
              });
              dots.appendChild(b);
            })(i);
          }
        }
        Array.prototype.forEach.call(dots.children, function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
        dots.hidden = pages < 2;
      };
      row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeDots);
  } else {
    initSwipeDots();
  }
  document.addEventListener('shopify:section:load', initSwipeDots);

  /* revealing hidden cards ("show more") changes the rows — refresh the dots */
  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('fm-more-in')) {
      window.dispatchEvent(new Event('resize'));
    }
  });

  /* respect reduced motion: hold the hero video on its poster frame */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', function () {
      Array.prototype.forEach.call(document.querySelectorAll('.fm-hero__video'), function (v) {
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) { /* ignore */ }
      });
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 900px)');
  var main = document.getElementById('MainContent');
  var route = null;
  var plane = null;
  var pathEl = null;
  var pathLength = 0;
  var cur = 0;
  var target = 0;
  var raf = null;
  var SAMPLES = 240;
  var sampleYs = null;
  var mainTop = 0;

  function planeSvg() {
    return (
      '<svg class="fm-plane" width="58" height="58" viewBox="0 0 32 32" aria-hidden="true">' +
      '<path d="M2 15 L30 3 L20 29 L14 19 Z" fill="#fff" stroke="rgba(0,0,0,0.55)" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M30 3 L14 19" stroke="rgba(0,0,0,0.55)" stroke-width="2"/></svg>'
    );
  }

  function ensureRoute() {
    if (route) return route;
    route = document.createElement('div');
    route.className = 'fm-route';
    route.setAttribute('aria-hidden', 'true');
    route.innerHTML =
      '<svg><path fill="none" stroke="rgba(0,0,0,0.22)" stroke-width="2" stroke-dasharray="1.5 11" stroke-linecap="round" d=""/></svg>' +
      '<div class="fm-route__plane">' + planeSvg() + '</div>';
    main.insertBefore(route, main.firstChild);
    pathEl = route.querySelector('path');
    plane = route.querySelector('.fm-route__plane');
    return route;
  }

  /* Catmull-Rom → cubic bezier through the anchor points */
  function smoothPath(points) {
    if (points.length < 2) return '';
    var d = 'M ' + points[0].x + ' ' + points[0].y;
    for (var i = 0; i < points.length - 1; i++) {
      var p0 = points[i - 1] || points[i];
      var p1 = points[i];
      var p2 = points[i + 1];
      var p3 = points[i + 2] || p2;
      var c1x = p1.x + (p2.x - p0.x) / 6;
      var c1y = p1.y + (p2.y - p0.y) / 6;
      var c2x = p2.x - (p3.x - p1.x) / 6;
      var c2y = p2.y - (p3.y - p1.y) / 6;
      d += ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ', ' + c2x.toFixed(1) + ' ' + c2y.toFixed(1) + ', ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1);
    }
    return d;
  }

  function anchors() {
    var mainRect = main.getBoundingClientRect();
    var top = mainRect.top + window.scrollY;
    var width = main.clientWidth;
    // fly in the empty side gutters, not over the content cards (route z1 < content z2)
    var pw = main.querySelector('.page-width');
    var gutter = pw ? Math.max(0, pw.getBoundingClientRect().left - mainRect.left) : width * 0.08;
    var gx = Math.max(30, gutter * 0.5);
    var sections = Array.prototype.slice.call(main.querySelectorAll('.fm-section'));
    var points = [];
    sections.forEach(function (section, i) {
      if (section.classList.contains('fm-sticky') || section.classList.contains('fm-hero')) return;
      var rect = section.getBoundingClientRect();
      var y = rect.top + window.scrollY - top + rect.height * 0.12;
      var x = i % 2 === 0 ? gx : width - gx;
      points.push({ x: x, y: y });
    });
    var hero = main.querySelector('.fm-hero .fm-hero__media');
    if (hero) {
      var hr = hero.getBoundingClientRect();
      points.unshift({ x: hr.left + hr.width * 0.5 - mainRect.left, y: hr.bottom + window.scrollY - top + 8 });
    }
    return points;
  }

  function layout() {
    if (!main) return;
    if (!desktop.matches) {
      if (route) route.style.display = 'none';
      return;
    }
    ensureRoute();
    route.style.display = '';
    var points = anchors();
    if (points.length < 2) {
      route.style.display = 'none';
      return;
    }
    var d = smoothPath(points);
    pathEl.setAttribute('d', d);
    pathLength = pathEl.getTotalLength ? pathEl.getTotalLength() : 0;
    plane.style.offsetPath = "path('" + d + "')";
    mainTop = main.getBoundingClientRect().top + window.scrollY;
    sampleYs = null;
    if (pathLength && pathEl.getPointAtLength) {
      sampleYs = new Array(SAMPLES + 1);
      for (var i = 0; i <= SAMPLES; i++) {
        sampleYs[i] = pathEl.getPointAtLength((pathLength * i) / SAMPLES).y;
      }
    }
    progress();
  }

  function progress() {
    if (!plane || !desktop.matches) return;
    if (reduceMotion.matches) {
      plane.style.offsetDistance = '100%';
      plane.style.opacity = '1';
      return;
    }
    if (sampleYs) {
      // aim for the point of the route whose height matches the middle of the
      // viewport, so the plane is always around where the visitor is looking
      var desired = window.scrollY + window.innerHeight * 0.5 - mainTop;
      var idx = 0;
      for (var i = 0; i <= SAMPLES; i++) {
        if (sampleYs[i] <= desired) idx = i;
      }
      target = idx / SAMPLES;
    } else {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      target = max > 0 ? Math.min(1, Math.max(0, (window.scrollY + window.innerHeight * 0.35) / max)) : 0;
    }
    startChase();
  }

  /* the plane chases the scroll target at a bounded pace, so a trackpad
     flick on a short viewport cannot teleport it across the page */
  function startChase() {
    if (raf) return;
    var step = function () {
      raf = null;
      var d = target - cur;
      if (Math.abs(d) < 0.0004) {
        cur = target;
      } else {
        cur += d * 0.055;
        raf = window.requestAnimationFrame(step);
      }
      plane.style.offsetDistance = (cur * 100).toFixed(2) + '%';
      plane.style.opacity = cur > 0.02 ? '1' : '0';
    };
    raf = window.requestAnimationFrame(step);
  }

  function onScroll() {
    progress();
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(layout, 120);
  }

  function boot() {
    // the route belongs to pages with the hero (homepage) — elsewhere this
    // script only provides the lightbox and video handlers above
    if (!main || !main.querySelector('.fm-hero')) return;
    if (!('offsetPath' in document.documentElement.style || 'OffsetPath' in document.documentElement.style)) return;
    layout();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    document.addEventListener('shopify:section:load', onResize);
    document.addEventListener('shopify:section:unload', onResize);
    document.addEventListener('shopify:section:reorder', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
